<template>
  <div class="winloss-page">
    <!-- 顶部导航 -->
    <div class="nav-bar">
      <span class="back-btn" @click="$router.go(-1)">&#8249;</span>
      <span class="nav-title">盈亏统计</span>
    </div>

    <!-- 加载中 -->
    <div v-if="loading" class="loading-wrap">
      <div class="loading-spinner"></div>
      <p>加载中...</p>
    </div>

    <div v-else>
      <!-- 四项汇总卡片 -->
      <div class="summary-grid">
        <div class="summary-card" :class="colorClass(data.today)">
          <div class="card-label">今日盈亏</div>
          <div class="card-value">{{ fmtMoney(data.today) }}</div>
        </div>
        <div class="summary-card" :class="colorClass(data.week)">
          <div class="card-label">本周盈亏</div>
          <div class="card-value">{{ fmtMoney(data.week) }}</div>
        </div>
        <div class="summary-card" :class="colorClass(data.month)">
          <div class="card-label">本月盈亏</div>
          <div class="card-value">{{ fmtMoney(data.month) }}</div>
        </div>
        <div class="summary-card" :class="colorClass(data.total)">
          <div class="card-label">历史总盈亏</div>
          <div class="card-value">{{ fmtMoney(data.total) }}</div>
        </div>
      </div>

      <!-- 投注统计补充信息 -->
      <div class="detail-box">
        <div class="detail-row">
          <span class="detail-label">总投注额</span>
          <span class="detail-val">{{ fmtMoney(data.total_bet) }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">有效投注额</span>
          <span class="detail-val">{{ fmtMoney(data.total_valid) }}</span>
        </div>
        <div class="detail-row" v-if="data.last_bet">
          <span class="detail-label">最近投注时间</span>
          <span class="detail-val">{{ data.last_bet }}</span>
        </div>
      </div>

      <!-- 说明文字 -->
      <p class="tips">
        * 盈亏数据每5分钟自动同步，实时结果以游戏平台为准。<br>
        * 正数表示盈利，负数表示亏损。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WinLoss',
  data() {
    return {
      loading: true,
      data: {
        today: 0,
        week: 0,
        month: 0,
        total: 0,
        total_bet: 0,
        total_valid: 0,
        last_bet: '',
      },
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$apiFun
        .post('/api/winloss', {})
        .then(res => {
          if (res && res.code === 200 && res.data) {
            this.data = res.data;
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    fmtMoney(val) {
      const n = parseFloat(val) || 0;
      const sign = n >= 0 ? '+' : '';
      return sign + n.toFixed(2);
    },
    colorClass(val) {
      const n = parseFloat(val) || 0;
      if (n > 0) return 'profit';
      if (n < 0) return 'loss';
      return 'zero';
    },
  },
};
</script>

<style scoped>
* { box-sizing: border-box; margin: 0; padding: 0; }

.winloss-page {
  min-height: 100vh;
  background: #f5f6fa;
  font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC', sans-serif;
}

/* 导航栏 */
.nav-bar {
  display: flex;
  align-items: center;
  height: 48px;
  background: #1a1a2e;
  color: #fff;
  padding: 0 16px;
  position: sticky;
  top: 0;
  z-index: 10;
}
.back-btn {
  font-size: 28px;
  cursor: pointer;
  margin-right: 12px;
  line-height: 1;
}
.nav-title {
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 1px;
}

/* 加载 */
.loading-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 0;
  color: #999;
}
.loading-spinner {
  width: 36px;
  height: 36px;
  border: 3px solid #e0e0e0;
  border-top-color: #e8b800;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-bottom: 12px;
}
@keyframes spin { to { transform: rotate(360deg); } }

/* 四宫格汇总 */
.summary-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  padding: 16px;
}
.summary-card {
  border-radius: 12px;
  padding: 18px 14px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}
.summary-card.profit {
  background: linear-gradient(135deg, #e8f5e9, #c8e6c9);
  border: 1px solid #a5d6a7;
}
.summary-card.loss {
  background: linear-gradient(135deg, #ffebee, #ffcdd2);
  border: 1px solid #ef9a9a;
}
.summary-card.zero {
  background: #fff;
  border: 1px solid #e0e0e0;
}
.card-label {
  font-size: 13px;
  color: #666;
  margin-bottom: 8px;
}
.card-value {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0.5px;
}
.profit .card-value { color: #2e7d32; }
.loss   .card-value { color: #c62828; }
.zero   .card-value { color: #555; }

/* 补充详情 */
.detail-box {
  margin: 0 16px;
  background: #fff;
  border-radius: 12px;
  padding: 14px 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}
.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f5f5f5;
  font-size: 14px;
}
.detail-row:last-child { border-bottom: none; }
.detail-label { color: #888; }
.detail-val   { color: #333; font-weight: 500; }

/* 说明 */
.tips {
  padding: 14px 16px;
  font-size: 12px;
  color: #aaa;
  line-height: 1.7;
}
</style>



// WEBPACK FOOTER //
// src/components/winloss.vue